module.exports = __webpack_public_path__ + "media/images/sale_crm/picklist-8f32a69ec0ae08897684e9dfb605a9e4.svg";